import React, { useEffect, useRef, useState } from "react"
import Form from "./elements/Form"
import PhoneInput from "./elements/PhoneInput"
import Recaptcha from "./elements/Recaptcha"
import TextInput from "./elements/TextInput"
import { brightCallSchema } from "./schemas"
import axios from "axios"
import useCallTeams from "@hooks/dataHooks/useCallTeams"
import { useGlobalStore } from "@stores/globalStore"
import { seoConData } from "@components/SearchResults/SearchFilters/filterOptions"
import { formTracking, generateUuid } from "./utils"
const BrightCallForm = ({ developer, onDone, onCompleted, sePhone, property, propertyURL }) => {
    // console.log(property)
    const { leadSource, utm_platform } = useGlobalStore()
    const allTeams = useCallTeams()
    const [matchingTeam, setMatchingTeam] = useState([]);
    const [status, setStatus] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const recaptchaRef = useRef()
    const getRandomTeams = (teams, count) => {
        const shuffled = [...teams].sort(() => 0.5 - Math.random());
        return shuffled.slice(0, count);
    };

    useEffect(() => {
        if (allTeams.length > 0) {
            const filteredTeams = allTeams.filter((team) =>
                team.developers.some((dev) => dev.slug === developer)
            );
            const resultTeams =
                filteredTeams.length > 0 ? filteredTeams : getRandomTeams(allTeams, 2);
            setMatchingTeam(resultTeams);
        }
    }, []);
    const generateAgentParams = (teams) => {
        const agentParams = {};
        teams.forEach((team, index) => {
            const agentIndex = (index + 1).toString().padStart(2, "0"); // Ensures two-digit format
            agentParams[`lc_param_agent${agentIndex}name`] = team.name;
            agentParams[`lc_param_agent${agentIndex}phone`] = team.phone;
            agentParams[`lc_param_agent${agentIndex}crm_id`] = team.crm_id;

        });
        return agentParams;
    };
    const onSubmit = async (data) => {
        setIsLoading(true);
        sePhone(data?.telephone)
        let seoSourceName = seoConData?.filter((item) => item.id.toString() === leadSource);
        let leadName = seoSourceName[0]?.name === "Organic" ? "Browser Direct" : seoSourceName[0]?.name
        // const token = await recaptchaRef.current?.executeAsync()
        // if (token) {
      const unique_id = generateUuid()
            try {
                const agentParams = generateAgentParams(matchingTeam); // Get dynamic agent params
                const requestBody = {
                    widget_key: "5613ef2ae3984234cd03197668ea692f",
                    api_key: "518d7bf8e81abf0b7c5546db5edecc0c22fd33c5",
                    lc_number: data?.telephone?.replace(/ /g, ""),
                    lc_param_name: data?.name,
                    lc_param_market_type:  seoSourceName && seoSourceName?.length > 0 && seoSourceName[0]?.name === "Organic" ? "Organic" : "Paid",
                    lc_param_developer : property?.bitrix?.developer_name,
                    lc_param_url : process.env.GATSBY_SITE_URL+propertyURL,
                    lc_param_campaign_name : property?.bitrix?.campaign_name,
                    // lc_utm_platform : utm_platform ? utm_platform : "",
                    lc_param_domain_name : "Providentestate Website",
                    lc_param_utm_source : seoSourceName && seoSourceName?.length > 0 && leadName,
                    lc_param_event_type : "Submit Form",
                    lc_param_original_source : "Brightcall",
                    ...agentParams, // Spread the dynamic agent parameters here
                };
                const response = await axios.post(
                    `https://app.convolo.ai/rest/v1/ext/add_call_api/`,
                    requestBody,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response?.data?.success) {
                    setIsLoading(false);
                    onDone(true)
                    setTimeout(() => {
                        onDone(false)
                        onCompleted(true)
                    }, 55000);
                    
                    setStatus("Lead submitted successfully!");
                    formTracking({
                                unique_id: unique_id,
                                eventTracking: "brightcall",
                                formName: "brightcall",
                                email: "",
                                phone: data?.telephone?.replace(/ /g, ""),
                                event_name: "brightcall"
                              })
                } else {
                    setIsLoading(false);
                    onCompleted(true)
                    setStatus("Failed to submit lead.");
                }
            } catch (error) {
                setIsLoading(false);
                onCompleted(true)
                console.error(error);
                setStatus("Failed to submit lead.");
            }


        // }


    }
    return (
        <Form
            className="showno-form"
            validationSchema={brightCallSchema}
            onSubmit={onSubmit}
            // successMsg={status}
            formname="bright"
        >
            {/* {property?.bitrix?.developer_name}<br/>
            {property?.bitrix?.campaign_name}<br/>
            {propertyURL}<br/>
            Providentestate Website<br/>
            {leadSource}<br/>
            {seoSourceName && seoSourceName?.length > 0 && seoSourceName[0]?.name === "Organic" ? "Browser Direct" : seoSourceName && seoSourceName?.length > 0 && seoSourceName[0]?.name} */}

            <div className="form-grid">
                <div className="row-full">
                    <TextInput name="name" placeholder="Name" label="Name" />
                </div>
                <div className="row-full">
                    <PhoneInput name="telephone" label="Phone" />
                </div>
            </div>
            <div className="form-bottom">
                <button className="button button-orange" type="submit">
                    <span>{isLoading ? "Submitting..." : "Submit Details"}</span>
                </button>
            </div>
            <Recaptcha recaptchaRef={recaptchaRef} />
        </Form>
    )
}

export default BrightCallForm